import { SoftwareAdskEditorForm } from './SoftwareAdskEditor.form'
import { Await, useLoaderData } from 'react-router-typesafe'
import { FormMode } from '@/enums'
import { softwareAdskRouteLoader } from '@/routes/software/adsk/SoftwareAdskEditor.route'
import { Suspense } from 'react'
import LoadingPanel from '@/components/loading-panel/LoadingPanel'
import { SoftwareAdskEditorProps } from '@/routes/software/adsk/SoftwareAdskEditor.types'
import { useFetcher } from 'react-router-dom'
import { isUserRoleAllowed } from '@/routes/utils'
import DocumentHead from '@/components/document-head/DocumentHead'

export function SoftwareAdskEditor(props: SoftwareAdskEditorProps) {
  const { title, swLicense, getClientList, getProductCatalog, getUserInfo, defaultCRUDAllowedRoles } =
    useLoaderData<typeof softwareAdskRouteLoader>()
  const fetcher = useFetcher()
  return (
    <>
      <Suspense fallback={<LoadingPanel />}>
        <Await resolve={Promise.all([getClientList, getProductCatalog, getUserInfo])}>
          {([aziende, products, userInfo]) => (
            <>
              <h2>{title}</h2>
              <div id="edit-adsk-license-container" className={`dx-card responsive-paddings`}>
                <SoftwareAdskEditorForm
                  license={swLicense}
                  mode={props.mode}
                  aziendaList={aziende.data.value}
                  productsList={products.data.value}
                  isRoleAllowed={isUserRoleAllowed(userInfo?.roles, defaultCRUDAllowedRoles)}
                  fetcher={fetcher}
                />
              </div>
            </>
          )}
        </Await>
      </Suspense>
    </>
  )
}
